<template>
    <div>
        <Advantages v-if="options && options.enableAdvantages"/>

        <div ref="rootAnchor" class="anchor"/>

        <CatalogControls
            class="my content"
            :hide-filter="$scope.EXPERIMENT_VAR == 0"
            @toggle-images-size="toggleImagesSize"/>

        <div id="catalog-main" class="content" :class="{busy: loading}">
            <OldCatalogFilters
                v-if="$scope.EXPERIMENT_VAR == 0 && options.enableFilters && ((products || {}).hits || []).length > 0"
                :class="{busy: showErrorMessage}"/>

            <div class="content text-center" v-if="showErrorMessage">
                <div class="alert-danger">
                    <span>Não foi possível carregar os produtos. Verifique sua conexão e atualize a página para tentar novamente.</span>
                    <span>Se o erro persistir, fale com a gente <a href="/fale-conosco">clicando aqui</a>.</span>
                </div>
            </div>
            <div v-else-if="loading" id="catalog-loading" class="pos-relative">
                <img class="pos-absolute pos-center-x"
                     src="https://chico-rei.s3.amazonaws.com/images/site/logo/diamond-loading-transparent.gif"
                     alt="Carregando resultados"/>
            </div>
            <div class="content text-center" v-else-if="!products || (products.hits || []).length === 0">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/site/catalog/art-no-results.png?auto=format&lossless=1&w=100&fit=crop`"
                    alt="Nenhum resultado"/>
                <p>Não encontramos resultados para a busca ou filtro utilizado.</p>
            </div>
            <div v-else>
                <ProductList
                    list-class="product-list product-list-4 product-list-gap-x-2 product-list-gap-y-4"
                    :products="products.hits"
                    :item-options="options"
                    :gender="gender"
                    :current-page="products.current_page"
                    :per-page="parseInt(products.per_page)"
                    :event-name="listEventName"
                    :selected-filters="selected"
                    :show-buy-button="!$scope.IS_REGULAR_CUSTOMER"/>
                <CatalogPagination
                    v-if="options && options.enablePagination"
                    class="mt"/>
            </div>
        </div>

        <div class="content" v-if="meta.content">
            <hr/>
            <div v-html="meta.content"></div>
        </div>

        <SalesRepCartCustomerManager/>
    </div>
</template>

<script>
    import CatalogPagination from "./CatalogPagination";
    import {readCookie, setCookie} from "../../../common/common";
    import Advantages from "../common/Advantages";
    import ProductList from "../common/ProductList";
    import SalesRepCartCustomerManager from "../sales-rep/SalesRepCartCustomerManager";
    import CatalogControls from "./CatalogControls";
    import {catalogStore} from "../../common/store/catalog-store";
    import OldCatalogFilters from "./OldCatalogFilters";

    export default {
        name: "Catalog",

        components: {
            OldCatalogFilters,
            CatalogControls,
            SalesRepCartCustomerManager,
            Advantages,
            ProductList,
            CatalogPagination
        },

        data() {
            return {
                storeState: catalogStore.state,
                showErrorMessage: false
            };
        },

        watch: {
            meta: {
                deep: true,
                handler(val) {
                    if (!val) return;

                    if (val.title) {
                        document.title = val.title;
                    }
                    if (val.description) {
                        let el = document.querySelector("meta[name='description']");

                        if (!el) {
                            el = document.createElement('meta');
                            el.setAttribute('name', 'description');
                            document.head.append(el);
                        }

                        el.setAttribute('content', val.description);
                    }
                    if (val.canonical) {
                        let el = document.querySelector("link[rel='canonical']");

                        if (!el) {
                            el = document.createElement('link');
                            el.setAttribute('rel', 'canonical');
                            document.head.append(el);
                        }
                        el.setAttribute('href', location.origin + val.canonical);
                    }
                },
            },

            selected: {
                immediate: true,
                handler(to) {
                    if (to) {
                        window.dataLayer.push({
                            'product-category-id': to.category ? to.category : to.type_id,
                            'product-category-name': to.category_name ? to.category_name : (to.partner_name ? to.partner_name : to.type_name),
                            'product-gender-category': to.gender_name ? to.gender_name : '',
                            'google_tag_params': {
                                'ecomm_pagetype': 'category',
                                'ecomm_category': to.category_name ? to.category_name : (to.partner_name ? to.partner_name : to.type_name)
                            },
                            'product-list-criteo': ((this.products || {}).hits || []).length > 0 ? this.products.hits.slice(0, 4).map(p => p.id + '') : []
                        });
                    }
                }
            },

            loading() {
                this.scrollToTop();
            }
        },

        computed: {
            products() {
                return this.storeState.products;
            },

            meta() {
                return this.storeState.meta;
            },

            options() {
                return this.storeState.options;
            },

            filters() {
                return this.storeState.filters;
            },

            selected() {
                return this.storeState.selected;
            },

            loading() {
                return this.storeState.loading;
            },

            gender() {
                const genderName = this.selected ? this.selected.gender_url : null;
                return genderName === 'masculino' ? 1 : genderName === 'feminino' ? 2 : 0;
            },

            listEventName() {
                if (this.selected) {
                    return (this.selected.partner_name ? (this.selected.partner_name + ' - ') : '') +
                        (this.selected.type_main_url ? this.selected.type_main_url : '') +
                        (this.selected.type_name ? ' - ' + this.selected.type_name : '') +
                        (this.selected.category_name ? ' - ' + this.selected.category_name : '') +
                        (this.selected.gender_name ? ' - ' + this.selected.gender_name : '');
                } else {
                    return null;
                }
            },
        },

        created() {
            if (this.products.per_page != '36' && this.products.per_page) {
                const url = new URL(window.location.href);
                url.searchParams.set('per_page', this.products.per_page);
                window.history.replaceState("", "", url.toString());
            }
        },

        methods: {
            scrollToTop() {
                cr$.byEl(this.$refs.rootAnchor).scrollIntoView(500);
            }
        },
    }
</script>